/**
 * iosHoverFix.js
 * File for fixing the hover bug in iOS mobile devices
 */

document.addEventListener('touchstart', function() {}, false);
